import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IReqPlatoTargetPayerDetails } from './plato-target.interface';

@Injectable({
  providedIn: 'root',
})
export class PlatoTargetService {
  private readonly payerDetailsUrl = '/api/v2/plato-target/payer-details';

  constructor(protected http: HttpClient) {}

  //Fire and forget method to submit payer details to Plato Target
  submitPayerDetails(request: IReqPlatoTargetPayerDetails): void {
    this.http.post(this.payerDetailsUrl, request).subscribe({
      error: () => {},
    });
  }
}
